import { render } from "./UdpViewer.vue?vue&type=template&id=73d06684"
import script from "./UdpViewer.vue?vue&type=script&lang=js"
export * from "./UdpViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__